/**
 * Gli orari del banco Datacom: lun-ven, 8:30-13:00 e 14:30-17:00 (Umberto,
 * riunione del 24/09/2026: «fino alle 17», Luca va via alle 17; prima 9-13 e
 * 15-18).
 *
 * La regola vera sta sul server (supabase/functions/_shared/orario_datacom.ts,
 * ora di Roma e festivi): questa copia serve solo a scrivere «aperto /
 * chiuso» e gli orari nei testi. Le FASCE devono essere le stesse: un test
 * (orarioDatacom.test.ts) le confronta. Il controllo qui usa l'ora del
 * telefono: gli installatori Datacom stanno in Italia, e sbagliare di un'ora
 * il cartellino per un utente in vacanza all'estero e' un danno minore che
 * portarsi dietro una libreria di fusi orari.
 */

export interface StatoBanco {
  aperto: boolean;
  /** Frase pronta per l'interfaccia. */
  messaggio: string;
}

export const FASCE: Array<[number, number]> = [
  [8 * 60 + 30, 13 * 60],
  [14 * 60 + 30, 17 * 60],
];

function oraTesto(minuti: number): string {
  const h = Math.floor(minuti / 60);
  const m = minuti % 60;
  return m === 0 ? `${h}` : `${h}:${String(m).padStart(2, "0")}`;
}

/** «lun-ven 8:30-13 e 14:30-17»: da usare in ogni testo che dice gli orari. */
export const ORARIO_BANCO = `lun-ven ${FASCE.map(([da, a]) => `${oraTesto(da)}-${oraTesto(a)}`).join(" e ")}`;

export function statoBanco(adesso: Date = new Date()): StatoBanco {
  const giorno = adesso.getDay(); // 0=domenica, 6=sabato
  const minuti = adesso.getHours() * 60 + adesso.getMinutes();
  const feriale = giorno >= 1 && giorno <= 5;
  const inFascia = FASCE.some(([da, a]) => minuti >= da && minuti < a);

  if (feriale && inFascia) {
    return { aperto: true, messaggio: "Il banco è aperto: ti rispondiamo ora." };
  }
  return {
    aperto: false,
    messaggio: `Il banco ora è chiuso (${ORARIO_BANCO}). Scrivi pure: ti rispondiamo alla riapertura.`,
  };
}
